/*
 * @Description: 一周口碑舆情分析
 * @Author: yy
 * @Date: 2019-05-31 14:47:28
 * @LastEditors: yy
 * @LastEditTime: 2019-09-24 10:05:18
 */


import React from 'react';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './p7.css';

import ExportHeadTitle from '../../../components/ExportHeadTitle';
import ExportDes from '../../../components/ExportDes';
import ExportFootDes from '../../../components/ExportFootDes';
import ExportEcharts from '../../../components/ExportEcharts';

import {getWordOfMouth, getUserFeelings} from '../../../controller';
import {wordOfMouth} from '../../../chart';
import { getSessionQuery, toThousands } from '../../../utils';

class P7 extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      query: {
        brandName: '',
        startDate: '',
        statisDate: ''
      },
      summary: {
        neArc: 0,
        badArc: 0,
        badPlat: '',
        badScale: '',
        likeArt: 0,
        likePlat: '',
        likeScale: ''
      },
      chart: {}
    };

    this.getData = this.getData.bind(this);
  }

  componentDidMount () {
    this.getData();
  }

  getQuery () {
    const query = getSessionQuery('query');
    const result = {
      brandName: query.brand,
      startDate: query.beginTime,
      statisDate: query.endTime
    }
    if (query.isCustom === '1') {
      // result.areaIndustry = query.industry
      result.competingBrands = query.competingGoods.map(item => item.value).join(',')
    }
    return result
  }

  getData () {
    const query = this.getQuery();
    Promise.all([getWordOfMouth(query), getUserFeelings(query)])
      .then(res => {
        const data = res[0]
        const data1 = res[1]
        console.log(res);
        this.setState({
          query: query,
          summary: {
            neArc: data.highlight.neArc,
            badArc: data.highlight.badArc,
            badPlat: data.highlight.badPlat,
            badScale: data.highlight.badScale,
            likeArt: data.highlight.likeArt,
            likePlat: data1.highlight.platform,
            likeScale: data.highlight.likeScale,
            goodMeanValue: data.goodMeanValue,
            badMeanValue: data.badMeanValue
          },
          chart: wordOfMouth(data, query)
        })
      })
  }

  render() {
    const {query, summary} = this.state;
    return (
      <div className={s.container}>
        <ExportHeadTitle>一周口碑舆情分析</ExportHeadTitle>
        <div>
          <ExportDes>
            对{query.brandName}品牌持好感态度的人群较多集中在{summary.likePlat}平台。
            {/* ，{query.brandName}品牌的好感阵营中KOL的分布密度较高 */}
            <br/>
            本周，{query.brandName}正面评价内容有{toThousands(summary.likeArt)}篇，占比{summary.likeScale}（全网均值{summary.goodMeanValue}），
            负面评价内容有{toThousands(summary.badArc)}篇，占比{summary.badScale}（全网均值{summary.badMeanValue}），
            中立类内容有{toThousands(summary.neArc)}篇。
          </ExportDes>
        </div>

        <div className={s.echartWrapper}>
          <ExportEcharts option={this.state.chart}></ExportEcharts>
        </div>

        <ExportFootDes
          brandName={query.brandName}
          beginTime={query.startDate}
          endTime={query.statisDate}>
        </ExportFootDes>
      </div>
    );
  }
}

export default withStyles(s)(P7);



// WEBPACK FOOTER //
// src/routes/exportPDF/p7/p7.js